module.exports = __webpack_public_path__ + "img/stock1.45a05c6d.png";